import React from 'react';
import OpenDNSBanner from './OpenDNSBanner';

class Error extends React.Component {
    render() {
        return(
            <div classnName="error-container">
                <section className="cisco-banner">
                    <div className="cisco-banner__logo">
                        <a href="http://www.cisco.com/" target="_blank">
                            <img src="https://d15ni2z53ptwz9.cloudfront.net/opendns-www/img/Cisco_Logo_RGB_Screen_White.png" className="cisco-banner__logo__img cisco-banner__logo__img--light" alt="OpenDNS is now a part of Cisco" title="OpenDNS is now a part of Cisco" />
                            <img src="https://d15ni2z53ptwz9.cloudfront.net/opendns-www/img/cisco-dark-logo.png" className="cisco-banner__logo__img cisco-banner__logo__img--dark" alt="OpenDNS is now a part of Cisco" title="OpenDNS is now a part of Cisco" />
                        </a>
                    </div>
                    <div className="cisco-banner__learn">
                        <p>
                            <span>OpenDNS is now part of Cisco</span>
                            <a href="http://www.cisco.com/web/about/ac49/ac0/ac1/ac259/opendns.html" target="_blank" className="cisco-banner__learnLink">
                                <span>Learn More </span>
                                <i className="fa fa-caret-right"></i>
                            </a>
                        </p>
                    </div>
                    <div className="cisco-banner__about">
                        <a href="http://www.cisco.com/web/about/index.html" target="_blank">About Cisco</a>
                    </div>
                </section>
                <OpenDNSBanner />

                <div className="grid">
                    <div className="centered-column">
                        <div className="warningBox">
                            <i className="fa fa-exclamation-triangle"></i>
                            <h3>We are sorry, we were unable to process your request.</h3>
                            <p>Check to make sure you haven't already signed up. You must be a new user to sign up for this service.</p>
                            <p>If you are a new user and still need help, please utilize our <a href="https://community.cisco.com/t5/opendns/bd-p/openDNS">community forum</a> for assistance.</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Error;



// WEBPACK FOOTER //
// ./src/components/Error.js